import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import config from "config";
import RouteURLs from "RouteURLs";
import NextRouteURLs from "NextRouteURLs";

import {
  AuthenticatedRoute,
  UnauthenticatedRoute,
} from "components/auth/routes";
import NotFoundPage from "pages/NotFound";
import PrivacyPolicyPage from "pages/legal/PrivacyPolicy";
import TermsAndConditionsPage from "pages/legal/TermsAndConditions";
import CookiesPage from "pages/legal/Cookies";
import ViewSpacePage from "pages/spaces/View";
import SpaceLandingPage from "pages/spaces/Landing";
import ListSpacesPage from "pages/spaces/List";
import LoginPage from "pages/auth/Login";
import RegisterPage from "pages/auth/Register";
import ResetPasswordPage from "pages/auth/ResetPassword";
import RequestPasswordResetPage from "pages/auth/RequestPasswordReset";
import DesignListPage from "pages/designs/List";
import EditDesignScreenGroupPage from "pages/designs/EditScreenGroup";
import BookingsListPage from "pages/bookings/List";
import PreviewDesignPage from "pages/designs/Preview";
import FAQPage from "pages/about/FAQ";
import TenantCalculatorPage from "pages/TenantCalculator";
import EditBookingTimePage from "pages/bookings/edit/Time";
import EditBookingAddOnsPage from "pages/bookings/edit/AddOns";
import EditBookingCheckOutPage from "pages/bookings/edit/CheckOut";
import EditBookingPage from "pages/bookings/edit";
import EditBookingSuccessPage from "pages/bookings/edit/Success";
import PressAndAwardsPage from "pages/about/PressAndAwards";
import ListBlogPostsPage from "pages/blog/List";
import ViewBlogDetailPage from "pages/blog/detail";
import ViewBlogReportPage from "pages/blog/Report";
import LandingTemplatePage from "pages/LandingTemplate";
import ViewDiscountPage from "pages/discounts/View";
import DashboardPage from "pages/Dashboard";
import SupportPage from "pages/Support";
import ListEventsPage from "pages/events/List";
import ViewAnalyticsPage from "pages/analytics/View";
import DownloadOccupationalLicensePage from "pages/bookings/DownloadOccupationalLicense";
import { UserGroup } from "services/entities/auth";
import LandlordDashboardPage from "pages/landlords/Dashboard";
import LandlordBookingsPage from "pages/landlords/Bookings";
import RebookPage from "pages/bookings/edit/Rebook";
import ExperiencePage from "pages/experiencePage";
import ThankYou from "pages/thankYouPage";
import AboutUs from "pages/about/AboutUs";
import BasicTemplate from "pages/basicTemplate";

export default class Routes extends Component<any, any> {
  render() {
    return (
      <Switch>
        {/* misc */}
        <Redirect exact path={"/tenant-calculator"} to={NextRouteURLs.HOME} />
        <Redirect exact path={"/events"} to={NextRouteURLs.HOME} />
        <Redirect exact path={"/bookyoursook"} to={NextRouteURLs.HOME} />
        <Redirect exact path={"/home-a"} to={NextRouteURLs.HOME} />
        <Redirect exact path={"/home-b"} to={NextRouteURLs.HOME} />
        <Redirect exact path={"/about"} to={NextRouteURLs.SOOK_VISION} />
        <Redirect exact path={"/about/faq"} to={NextRouteURLs.FAQ} />
        <Redirect
          exact
          path={"/about/press-and-awards"}
          to={NextRouteURLs.PRESS_AND_AWARDS}
        />
        <Route
          component={BasicTemplate}
          exact
          path={RouteURLs.BASIC_TEMPLATE}
        />
        <Route
          component={LandingTemplatePage}
          exact
          path={RouteURLs.LANDING_TEMPLATE}
        />
        <Route
          component={TenantCalculatorPage}
          exact
          path={RouteURLs.TENANT_CALCULATOR}
        />
        <Route
          exact
          path={RouteURLs.CROWDFUNDING}
          render={() => (window.location.href = config.crowdfunding.url)}
        />
        <Route component={SupportPage} exact path={RouteURLs.SUPPORT} />
        <Route component={NotFoundPage} exact path={RouteURLs.NOT_FOUND} />
        {/* experience */}
        <Route component={ExperiencePage} exact path={RouteURLs.EXPERIENCE} />
        {/* about */}
        <Route component={FAQPage} exact path={NextRouteURLs.FAQ} />
        <Route
          component={PressAndAwardsPage}
          exact
          path={NextRouteURLs.PRESS_AND_AWARDS}
        />
        {/* blog */}
        <Route component={ListBlogPostsPage} exact path={NextRouteURLs.BLOG} />
        <Route
          component={ViewBlogDetailPage}
          exact
          path={RouteURLs.VIEW_BLOG_DETAIL}
        />
        <Route
          component={ViewBlogReportPage}
          exact
          path={RouteURLs.VIEW_BLOG_REPORT}
        />
        {/* legal */}
        <Route
          component={TermsAndConditionsPage}
          exact
          path={NextRouteURLs.TERMS_AND_CONDITIONS}
        />
        <Route
          component={PrivacyPolicyPage}
          exact
          path={NextRouteURLs.PRIVACY}
        />
        <Route component={CookiesPage} exact path={RouteURLs.COOKIES} />
        {/* spaces */}
        <Route component={ListSpacesPage} exact path={NextRouteURLs.SPACES} />
        <Route component={ViewSpacePage} exact path={RouteURLs.VIEW_SPACE} />
        <Route
          component={SpaceLandingPage}
          exact
          path={RouteURLs.SPACE_LANDING}
        />
        <Redirect
          exact
          path={RouteURLs.BOOK_SPACE}
          to={RouteURLs.CREATE_BOOKING + "?space=:slug"}
        />
        {/* account */}
        <Route
          component={() => <UnauthenticatedRoute component={LoginPage} />}
          exact
          path={RouteURLs.LOGIN}
        />
        <Route
          component={() => <UnauthenticatedRoute component={RegisterPage} />}
          exact
          path={RouteURLs.REGISTER}
        />
        <Route
          component={() => (
            <UnauthenticatedRoute component={ResetPasswordPage} />
          )}
          exact
          path={RouteURLs.RESET_PASSWORD}
        />
        <Route
          component={() => (
            <UnauthenticatedRoute component={RequestPasswordResetPage} />
          )}
          exact
          path={RouteURLs.REQUEST_PASSWORD_RESET}
        />
        {/* dashboard */}
        <Route
          component={() => (
            <AuthenticatedRoute
              requiredGroup={UserGroup.Customer}
              component={DashboardPage}
            />
          )}
          exact
          path={RouteURLs.DASHBOARD}
        />
        {/* designs */}
        <Route
          component={() => (
            <AuthenticatedRoute
              requiredGroup={UserGroup.Customer}
              component={DesignListPage}
            />
          )}
          exact
          path={RouteURLs.DESIGN_LIST}
        />
        <Route
          component={() => (
            <AuthenticatedRoute
              requiredGroup={UserGroup.Customer}
              component={EditDesignScreenGroupPage}
            />
          )}
          exact
          path={RouteURLs.EDIT_DESIGN_SCREEN_GROUP}
        />
        <Route
          component={() => (
            <AuthenticatedRoute
              requiredGroup={UserGroup.Customer}
              component={PreviewDesignPage}
            />
          )}
          exact
          path={RouteURLs.PREVIEW_DESIGN}
        />
        {/* bookings */}
        <Route
          component={() => (
            <AuthenticatedRoute
              requiredGroup={UserGroup.Customer}
              component={BookingsListPage}
            />
          )}
          exact
          path={RouteURLs.BOOKINGS_LIST}
        />
        <Route
          component={EditBookingPage}
          exact
          path={RouteURLs.CREATE_BOOKING}
        />
        <Route
          component={EditBookingTimePage}
          exact
          path={RouteURLs.CREATE_BOOKING_TIME}
        />
        <Route
          component={EditBookingAddOnsPage}
          exact
          path={RouteURLs.CREATE_BOOKING_ADDONS}
        />
        <Route
          component={EditBookingCheckOutPage}
          exact
          path={RouteURLs.CREATE_BOOKING_CHECK_OUT}
        />
        <Route
          component={EditBookingPage}
          exact
          path={RouteURLs.EDIT_BOOKING}
        />
        <Route
          component={EditBookingTimePage}
          exact
          path={RouteURLs.EDIT_BOOKING_TIME}
        />
        <Route
          component={EditBookingAddOnsPage}
          exact
          path={RouteURLs.EDIT_BOOKING_ADDONS}
        />
        <Route
          component={EditBookingCheckOutPage}
          exact
          path={RouteURLs.EDIT_BOOKING_CHECK_OUT}
        />
        <Route
          component={EditBookingSuccessPage}
          exact
          path={RouteURLs.EDIT_BOOKING_SUCCESS}
        />
        <Route
          component={() => (
            <AuthenticatedRoute component={DownloadOccupationalLicensePage} />
          )}
          exact
          path={RouteURLs.BULK_DOWNLOAD_OCCUPATIONAL_LICENSE}
        />
        <Route component={RebookPage} exact path={RouteURLs.REBOOK} />
        {/* analytics */}
        <Route
          component={() => (
            <AuthenticatedRoute
              requiredGroup={UserGroup.Customer}
              component={ViewAnalyticsPage}
            />
          )}
          exact
          path={RouteURLs.VIEW_ANALYTICS}
        />
        {/* discounts */}
        <Route
          component={ViewDiscountPage}
          exact
          path={RouteURLs.VIEW_DISCOUNT}
        />
        {/* landlords */}
        <Route
          component={() => (
            <AuthenticatedRoute
              requiredGroup={UserGroup.Landlord}
              component={LandlordDashboardPage}
            />
          )}
          exact
          path={RouteURLs.LANDLORD_DASHBOARD}
        />
        <Route
          component={() => (
            <AuthenticatedRoute
              requiredGroup={UserGroup.Landlord}
              component={LandlordBookingsPage}
            />
          )}
          exact
          path={RouteURLs.LANDLORD_BOOKINGS}
        />
        {/* events */}
        <Route component={ListEventsPage} exact path={RouteURLs.EVENTS_LIST} />
        {/* confirmation */}
        <Route
          component={ThankYou}
          exact
          path={RouteURLs.THANK_YOU_LANDING_PAGE}
        />
        <Route
          component={ThankYou}
          exact
          path={RouteURLs.THANK_YOU_BOOKING_BAR}
        />
        <Route component={AboutUs} exact path={NextRouteURLs.SOOK_VISION} />
        <Redirect to={RouteURLs.NOT_FOUND} />
      </Switch>
    );
  }
}
